class StepNotFound extends Error {}

export default StepNotFound;
